export interface UserPreferenceItem {
  id: string;
  type: string;
  enabled: boolean;
  // false = opted-in but awaiting DE double opt-in confirmation. LPB-1506.
  confirmed?: boolean | null;
}

export const getPreferenceByType = (
  preferences: UserPreferenceItem[] | undefined,
  type: string,
): UserPreferenceItem | undefined => preferences?.find((p) => p.type === type);
